import React from 'react';
import { DNAButton } from '@alucio/lux-ui';
import useSelector, { composite } from 'src/hooks/useSelector';
import * as customNotesSelector from 'src/state/machines/customNote/customNote.selectors';
import SidebarContent from '../../SideBarContent';
import { tabConfigs } from '../..';
import CustomNotesProvider, { useCustomNotes } from './CustomNotesProvider';
import { CustomNotes } from '.';
import { useContentPreviewModal } from '../../../State/ContentPreviewModalStateProvider';
import * as logger from 'src/utils/logger';

const TextInsertionRightElement: React.FC = () => {
  const {
    service,
    createNotationWithCoordinate,
    currentPageNotationsInfo,
  } = useCustomNotes()

  const cond = useSelector(
    service,
    (state) => composite(
      state,
      customNotesSelector.isInitializingState,
      customNotesSelector.isIdleState,
      customNotesSelector.canInsertText,
      customNotesSelector.isReadOnlyMode,
    ),
  )

  const hideContextMenu = cond.isReadOnlyMode ||
    cond.isInitializingState || currentPageNotationsInfo.hasMeetNotationLimits;

  if (hideContextMenu) return null
  return (
    <DNAButton
      testID="text-insertion-create-button"
      appearance="outline"
      status="tertiary"
      iconRight="plus"
      onPress={createNotationWithCoordinate}
      disabled={!cond.isIdleState}
    />
  )
}

const TextInsertionWrapper: React.FC = () => {
  const { canCurrentSlideInsertText } = useContentPreviewModal();

  if (!canCurrentSlideInsertText) {
    logger.userNotations.error('Current slide doesn\'t have TextInsertion enabled');
    return null;
  }

  return (
    <CustomNotesProvider isTextInsertion>
      <SidebarContent>
        <SidebarContent.Header
          sidebarHeader={tabConfigs.textInsertion.label}
          descriptionText={'Inserted texts will not appear when this file\nis downloaded or shared'}
          rightElement={<TextInsertionRightElement/>}
        />
        <SidebarContent.Body>
          <CustomNotes />
        </SidebarContent.Body>
      </SidebarContent>
    </CustomNotesProvider>
  )
}

export default TextInsertionWrapper;
